import { FileText } from "lucide-react";
import "./index.css";

export default function CompanyProfile() {
  return (
    <div className="company-profile-container">
      <div className="company-profile-hero-section">
        <div className="company-profile-hero-overlay">
          <h1 className="company-profile-hero-title">COMPANY PROFILE</h1>
        </div>
      </div>

      <div className="company-profile-content-section">
        <div className="company-profile-pdf-download">
          <a
            href="/img/Company-Profile.pdf"
            className="company-profile-pdf-button"
            target="_blank"
          >
            <div className="company-profile-pdf-icon1">
              <FileText size={24} />
            </div>
            <div className="company-profile-pdf-text">
              <span>COMPANY</span>
              <span>PROFILE</span>
            </div>
          </a>
        </div>

        {/* Brief Introduction */}
        <div className="company-profile-intro-section">
          <h2 className="company-profile-intro-title">BRIEF INTRODUCTION</h2>
          <p className="company-profile-intro-text">
            Securities Pvt. Limited believes in constant evolution towards a
            higher stature. Thanks to the experience from our past and a clear
            vision of our future direction, we have over time evolved into a
            top-notch brokerage house anticipating and satisfying customer needs
            through synchronized team effort and utmost professionalism. In
            fact, our corporate objective emphasizes customer satisfaction by
            ensuring our clients get up-to-date information and premium quality
            service at all times.
          </p>

          <p className="company-profile-intro-text">
            <strong>
              ORBIT SECURITIES PRIVATE LIMITED – PASSION FOR EXCELLENCE!
            </strong>
            <br />
            We strive for excellence with passion in all of our businesses and
            with a focused approach— aptly captured in our company’s tagline:{" "}
            <em>“Prominence through Excellence.”</em>
          </p>

          <p className="company-profile-intro-text">
            Orbit Securities Pvt. Limited takes pride in its ability to deliver
            innovative financial solutions to a growing client base currently
            comprising domestic and international clients. We have assembled a
            core team of expert professionals with a high level of integrity,
            financial acumen, and industry experience. Our efforts are to be
            client-focused, service-driven, and growth-oriented, striving for
            excellence as the best brokerage house and provider of premier
            investment services through strong organizational values, personal
            character, and integrity—thus making meaningful contributions to our
            capital market.
          </p>

          <p className="company-profile-intro-text">
            Orbit Securities Private Limited is one of the emerging brokerage
            houses in Pakistan. Orbit Securities Limited was incorporated as a
            Private Limited Company under the Companies Ordinance, 1984. The
            Corporate Registration Number is <strong>0198535</strong> & Pakistan
            Stock Exchange TREC holder Number.
          </p>
        </div>

        <div className="company-profile-services-section">
          <h2 className="company-profile-services-title">RELATION & BUSINESS SCOPE</h2>

          <div className="company-profile-service-box">
            <h3 className="company-profile-service-heading">
            DETAIL OF PERMISSIBLE BUSINESS
            </h3>
            <p className="company-profile-service-text">
            The Orbit Securities Private Limited is the TREC holder of Pakistan Stock Exchange Limited and is also registered with Securities and Exchange Commission of Pakistan to carry on the Stock Brokerage Business.
            </p>
          </div>

          <div className="company-profile-service-box">
            <h3 className="company-profile-service-heading">
            OUR STRATEGY
            </h3>
            <p className="company-profile-service-text">
            To constantly assess and monitor our clients’ needs and provide premium quality services to meet these needs.
            </p>
          </div>

          <div className="company-profile-service-box">
            <h3 className="company-profile-service-heading">
            OUR RELATIONSHIP WITH CLIENT
            </h3>
            <p className="company-profile-service-text">
            We believe that client satisfaction is the only way to sustained improvement. Our activities are geared towards helping out investors to enhance their portfolio performance and to take part in the future growth of the Capital Market. Our successful investment ideas and recommendations assist our clients in making improved decisions for building their wealth.
            </p>
          </div>
        </div>

        {/* Our Services */}
        <div className="company-profile-services-section">
          <h2 className="company-profile-services-title">OUR SERVICES</h2>

          <div className="company-profile-service-box">
            <h3 className="company-profile-service-heading">
              EXPERT INVESTMENT SERVICES
            </h3>
            <p className="company-profile-service-text">
            we are committed to providing comprehensive, transparent, and innovative brokerage services tailored to meet the diverse needs of both companies and individual investors. Our expertise in investment strategies, market analysis, and trading solutions ensures that our clients receive the best financial services with a focus on growth, security, and long-term success. Whether you are an institutional investor, a corporate entity, or an individual trader, we are here to guide you through every step of your investment journey. Our services are designed to maximize returns, minimize risks, and provide seamless access to Pakistan’s stock market with the latest technology and expert financial insights.
            </p>
          </div>

          <div className="company-profile-service-box">
            <h3 className="company-profile-service-heading">
              PERSONALIZED INVESTMENT GUIDANCE
            </h3>
            <p className="company-profile-service-text">
            We offer one-on-one financial consultations to help investors identify market opportunities, manage risks, and create customized investment plans that align with their financial goals.
            </p>
          </div>

          <div className="company-profile-service-box">
            <h3 className="company-profile-service-heading">
              SECURE & ADVANCED TRADING PLATFORMS
            </h3>
            <p className="company-profile-service-text">
            Our state-of-the-art trading platforms provide real-time market updates, seamless trade execution, and user-friendly interfaces to ensure a smooth trading experience for investors at all levels.
            </p>
          </div>
        </div>

        <div className="team-section">
          <h2 className="team-title">MEET OUR TEAM</h2>

          <div className="team-member">
            <h3 className="team-member-name">Veena</h3>
            <p className="team-member-role">Finance Manager</p>
            <p className="team-member-description">
              Veena, our proficient Finance Manager, holds a Bachelor’s degree
              in Accounting & Finance. With a strong foundation in financial
              planning, budgeting, and risk management, she plays a key role in
              ensuring the company's financial stability and efficiency. Her
              expertise in financial analysis and strategic decision-making
              helps drive sustainable growth while maintaining compliance with
              industry standards.
            </p>
          </div>

          {/* <div className="team-member">
            <h3 className="team-member-name">Muhammad Aadil</h3>
            <p className="team-member-role">Compliance Officer</p>
            <p className="team-member-description">
              Mr. Muhammad Umair, our dedicated Compliance Officer, holds a
              Bachelor’s degree in Commerce and has been an integral part of our
              team for the past three years. With extensive expertise in
              financial regulations, risk management, and corporate compliance,
              he ensures that our brokerage operations strictly adhere to
              government policies and industry standards. His unwavering
              commitment to transparency, ethical practices, and
              regulatory compliance.
            </p>
          </div>

          <div className="team-member">
            <h3 className="team-member-name">Mr. Asif</h3>
            <p className="team-member-role">Settlement Officer</p>
            <p className="team-member-description">
              Muhammad Asif, our experienced Settlement Officer, brings 10 years
              of expertise in the stock market and has been an integral part of
              Orbit Securities (PVT LTD) for the past three years. His in-depth
              knowledge of trade settlements, transaction processing, and
              regulatory compliance ensures smooth and efficient post-trade
              operations. With a strong focus on accuracy and timeliness, he
              plays a vital role in maintaining seamless financial transactions
              and enhancing client confidence.
            </p>
          </div> */}
        </div>
      </div>
    </div>
  );
}
